import React from "react";
import { 
  Table, 
  TableBody, 
  TableCell, 
  TableHead, 
  TableHeader, 
  TableRow 
} from "../../components/ui/table";
import FileIcon from "./FileIcon";
import FileActions from "./FileActions";
import { FileItem } from "../../types/file";

interface FileListViewProps {
  files: FileItem[];
  copiedLinkId: string | null;
  onCopyLink: (id: string, url: string) => void;
  onDelete: any;
}



const formatFileSize = (bytes: any) => {  
    if (bytes === 0) return '0 Bytes';  
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];  
    const i = Math.floor(Math.log(bytes) / Math.log(1024));  
    return parseFloat((bytes / Math.pow(1024, i)).toFixed(2)) + ' ' + sizes[i];  
  }; 

const FileListView = ({ files, copiedLinkId, onCopyLink, onDelete }: FileListViewProps) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Name</TableHead>
          <TableHead>Type</TableHead>
          <TableHead>Size</TableHead>
          {/* <TableHead>Upload Date</TableHead> */}
          <TableHead className="text-right">Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {files?.map((file) => (
          <TableRow key={file.id}>
            <TableCell className="font-medium">
              <div className="flex items-center gap-2">
                <FileIcon type={file.type} />
                <span>{file.name}</span>
              </div>
            </TableCell>
            <TableCell>
              {file?.type?? ''}
            </TableCell>
            <TableCell>{Number(file?.size)}</TableCell>
            {/* <TableCell>{new Date(file.uploadDate).toLocaleDateString()}</TableCell> */}
            <TableCell className="text-right">
              <FileActions 
                fileId={file.id}
                fileUrl={file.url}
                fileName={file.name}
                onDelete={onDelete}
                copiedLinkId={copiedLinkId}
                onCopyLink={onCopyLink}
                variant="buttons"
                className={"ml-2"}
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default FileListView;